export type FirebasePublicConfig = {
  apiKey: string;
  authDomain: string;
  projectId: string;
  storageBucket: string;
  messagingSenderId: string;
  appId: string;
  measurementId?: string;
};

/** sazsoz-web — public web config (override via NEXT_PUBLIC_FIREBASE_* on Cloudflare build). */
const FIREBASE_WEB_DEFAULTS: FirebasePublicConfig = {
  apiKey: "AIzaSyBjRjgBqgw63U2yZyhKBqJ2vBkS_-C7TvE",
  authDomain: "auth.sazsoz.app",
  projectId: "sazsoz",
  storageBucket: "sazsoz.firebasestorage.app",
  messagingSenderId: "9387396431",
  appId: "1:9387396431:web:62ed64ec55bb9aeb56093a",
  measurementId: "G-QDWN9XWYZ2",
};

function envOrDefault(
  envValue: string | undefined,
  fallback: string,
): string {
  const trimmed = envValue?.trim();
  return trimmed || fallback;
}

export function getFirebasePublicConfig(): FirebasePublicConfig {
  return {
    apiKey: envOrDefault(
      process.env.NEXT_PUBLIC_FIREBASE_API_KEY,
      FIREBASE_WEB_DEFAULTS.apiKey,
    ),
    authDomain: envOrDefault(
      process.env.NEXT_PUBLIC_FIREBASE_AUTH_DOMAIN,
      FIREBASE_WEB_DEFAULTS.authDomain,
    ),
    projectId: envOrDefault(
      process.env.NEXT_PUBLIC_FIREBASE_PROJECT_ID,
      FIREBASE_WEB_DEFAULTS.projectId,
    ),
    storageBucket: envOrDefault(
      process.env.NEXT_PUBLIC_FIREBASE_STORAGE_BUCKET,
      FIREBASE_WEB_DEFAULTS.storageBucket,
    ),
    messagingSenderId: envOrDefault(
      process.env.NEXT_PUBLIC_FIREBASE_MESSAGING_SENDER_ID,
      FIREBASE_WEB_DEFAULTS.messagingSenderId,
    ),
    appId: envOrDefault(
      process.env.NEXT_PUBLIC_FIREBASE_APP_ID,
      FIREBASE_WEB_DEFAULTS.appId,
    ),
    measurementId: envOrDefault(
      process.env.NEXT_PUBLIC_FIREBASE_MEASUREMENT_ID,
      FIREBASE_WEB_DEFAULTS.measurementId ?? "",
    ),
  };
}

export function isFirebaseConfigured(): boolean {
  const { apiKey, projectId, appId } = getFirebasePublicConfig();
  return Boolean(apiKey && projectId && appId);
}

/** reCAPTCHA v3 site key registered in Firebase Console → App Check (public). */
export function getFirebaseAppCheckSiteKey(): string | undefined {
  const key = process.env.NEXT_PUBLIC_FIREBASE_APP_CHECK_SITE_KEY?.trim();
  return key || undefined;
}
